import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import ProtectedAdminRoute from './components/ProtectedAdminRoute/ProtectedAdminRoute';
import Home from './pages/Home/Home';
import Committees from './pages/Committees/Committees';
import Speakers from './pages/Speakers/Speakers';
import AbstractSubmission from './pages/AbstractSubmission/AbstractSubmission';
import Registration from './pages/Registration/Registration';
import RegistrationSuccess from './pages/RegistrationSuccess/RegistrationSuccess';
import Accommodation from './pages/Accommodation/Accommodation';
import Travel from './pages/Travel/Travel';
import ProgramSchedule from './pages/ProgramSchedule/ProgramSchedule';
import Sponsorship from './pages/Sponsorship/Sponsorship';
import Gallery from './pages/Gallery/Gallery';
import Contact from './pages/Contact/Contact';
import Login from './pages/Login/Login';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword';
import Dashboard from './pages/Dashboard/Dashboard';
import ConferenceRegistration from './pages/ConferenceRegistration/ConferenceRegistration';
import AccommodationBooking from './pages/AccommodationBooking/AccommodationBooking';
import FeeStructure from './pages/FeeStructure/FeeStructure';
import AdminDashboard from './pages/AdminDashboard/AdminDashboard';
import AdminLogin from './pages/AdminLogin/AdminLogin';
import Brochure from './pages/Brochure/Brochure';

// Scroll to top component
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

// 404 Page Component
const NotFound = () => (
  <div className="page-padding text-center" style={{ minHeight: '60vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
    <h1 style={{ fontSize: '5rem', color: '#002147' }}>404</h1>
    <h2 style={{ marginBottom: '20px' }}>Page Not Found</h2>
    <p style={{ marginBottom: '30px' }}>The page you are looking for does not exist or has been moved.</p>
    <a href="/" className="btn btn-primary">Go Back Home</a>
  </div>
);

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Navbar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/committees" element={<Committees />} />
            <Route path="/speakers" element={<Speakers />} />
            <Route path="/abstract-submission" element={<AbstractSubmission />} />
            <Route path="/registration" element={<Registration />} />
            <Route path="/registration-success" element={<RegistrationSuccess />} />
            <Route path="/fee-structure" element={<FeeStructure />} />
            <Route path="/accommodation" element={<Accommodation />} />
            <Route path="/travel" element={<Travel />} />
            <Route path="/brochure" element={<Brochure />} />
            <Route path="/program-schedule" element={<ProgramSchedule />} />
            <Route path="/sponsorship" element={<Sponsorship />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/conference-registration" element={<ConferenceRegistration />} />
            <Route path="/accommodation-booking" element={<AccommodationBooking />} />
            
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route 
              path="/admin/dashboard" 
              element={
                <ProtectedAdminRoute>
                  <AdminDashboard />
                </ProtectedAdminRoute>
              } 
            />
            
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
